import { render, staticRenderFns } from "./SampleInventory.vue?vue&type=template&id=2c35b195&scoped=true"
import script from "./SampleInventory.vue?vue&type=script&lang=js"
export * from "./SampleInventory.vue?vue&type=script&lang=js"
import style0 from "./SampleInventory.vue?vue&type=style&index=0&id=2c35b195&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c35b195",
  null
  
)

export default component.exports